import API from '../shared/intersection.axios';
import config from '../config.json'
import {showError, showSuccess} from '../shared/notify.component';

const state = () => {
	return {
		budgets: []
	};
};

// getters
const getters = {
	getBudgets(state) {
		return state.budgets;
	}
};

// actions
const actions = {

	setDefault({commit, dispatch}, data) {

		dispatch('shared/setLoading', true, {root: true})

		return API.get(config.endpoints.setDefaultBudget + '?id=' + data.id + "&decision=" + (data.decision ? '1' : '0'))
		.then(response => {
			showSuccess(response.data.message, this._vm.$toast)
			commit('setDefaultBudget', data);
			dispatch('shared/setLoading', false, {root: true})
			return response.data
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	add({commit, dispatch}, data) {

		dispatch('shared/setLoading', true, {root: true})

		return API.post(config.endpoints.addBudget, data)
		.then(response => {
			commit('addBudget', response.data.result[0]);
			showSuccess(response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	getAllPdf({commit, dispatch}, data) {

		dispatch('shared/setLoading', true, {root: true})

		return API.get(config.endpoints.getBudgets + '?plan_id=' + data.id, {tempToken: data.token})
		.then(response => {
			commit('setBudgets', response.data.result);
			dispatch('shared/setLoading', false, {root: true})

		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	getAll({commit, dispatch}, id) {

		dispatch('shared/setLoading', true, {root: true})

		return API.get(config.endpoints.getBudgets + '?plan_id=' + id)
		.then(response => {
			commit('setBudgets', response.data.result);
			dispatch('shared/setLoading', false, {root: true})
			return response.data.result
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	getSinglePdf({dispatch}, data) {

		// dispatch('shared/setLoading', true, {root: true})

		return API.get(config.endpoints.getBudget + '?id=' + data.id, {tempToken: data.token})
		.then(response => {
			dispatch('shared/setLoading', false, {root: true})
			return response.data.result[0];
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	getSingle({dispatch}, id) {

		// dispatch('shared/setLoading', true, {root: true})

		return API.get(config.endpoints.getBudget + '?id=' + id)
		.then(response => {
			dispatch('shared/setLoading', false, {root: true})
			return response.data.result[0];
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	update({dispatch}, data) {

		dispatch('shared/setLoading', true, {root: true})

		return API.post(config.endpoints.updateBudget, data)
		.then(response => {
			showSuccess(response.data.message, this._vm.$toast)
			return response.data.result[0];
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	duplicate({dispatch}, data) {

		dispatch('shared/setLoading', true, {root: true})

		return API.post(config.endpoints.duplicateBudget, data)
		.then(response => {
			showSuccess(response.data.message, this._vm.$toast)
			return response;
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	loadSection({dispatch}, data) {

		let id = null
		let options = {}
		if (data.id == undefined) {
			id = data
		} else {
			id = data.id
			options = {tempToken: data.token}
		}

		dispatch('shared/setLoading', true, {root: true})

		return API.get(config.endpoints.getBudgetSection + '?id=' + id + '&group=false', options)
		.then(response => {
			dispatch('shared/setLoading', false, {root: true})
			return response.data;
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},

	addSectionRecord({commit, dispatch}, data) {

		dispatch('shared/setLoading', true, {root: true})

		return API.post(config.endpoints.addBudgetRecord, data)
		.then(response => {
			dispatch('shared/setLoading', false, {root: true})
			return response;
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});
	},
	updateSectionRecord({commit, dispatch}, data) {

		dispatch('shared/setLoading', true, {root: true})

		let record = Object.assign({}, data);

		let id = record.id
		delete record.id

		return API.post(config.endpoints.updateBudgetRecord + id, record)
		.then(response => {
			dispatch('shared/setLoading', false, {root: true})
			return response;
		})
		.catch((error) => {
			showError(error.response.data.message, this._vm.$toast)
			dispatch('shared/setLoading', false, {root: true})
		});

	},
	delete({dispatch, commit}, budgetId) {
		dispatch('shared/setLoading', true, {root: true})
		return API.get(config.endpoints.deleteBudgetRecord + budgetId)
		.then(response => {
			commit('deleteBudget', budgetId)
			dispatch('shared/setLoading', false, {root: true})
			showSuccess(response.data.message, this._vm.$toast)
		})
		.catch((error) => {
			showError(error.response.data.error, this._vm.$toast)
		})
	},

	deleteItem({dispatch, commit}, itemId) {
		dispatch('shared/setLoading', true, {root: true})
		return API.get(config.endpoints.deleteBudgetItem + itemId)
		.then(response => {
			dispatch('shared/setLoading', false, {root: true})
			showSuccess(response.data.message, this._vm.$toast)
		})
		.catch((error) => {
			showError(error.response.data.error, this._vm.$toast)
		})
	}

};

// mutations
const mutations = {
	setDefaultBudget(state, data) {

		state.budgets.forEach((item) => {

			if (data.decision && item.id == data.id) {
				item.default = 1
			} else {
				item.default = 0
			}
		})
	},
	setBudgets(state, budgets) {
		state.budgets = budgets;
	},
	addBudget(state, budget) {
		state.budgets.push(budget);
	},
	deleteBudget(state, budgetId) {
		state.budgets = state.budgets.filter(budget => budget.id !== budgetId)
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
